var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"box"},[_c('box2'),_c('box5'),_c('box6'),_c('box3')],1)}
var staticRenderFns = []

export { render, staticRenderFns }